import { Link } from "react-router-dom";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../clients/utils/AuthContext";
import { Menu, X, User, ChevronDown } from "lucide-react";
import Cookies from "js-cookie";

function Header() {
  const [open, setOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const { user, dispatch } = useContext(AuthContext);
  console.log("USER HEADER:", user);

  // 🔥 scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    Cookies.remove("user_token", {
      path: "/",
      domain: ".komorotel.com",
    });

    dispatch({ type: "LOGOUT" });
    setDropdown(false);
  };

  return (
    <header
      className={`
        fixed top-0 left-0 w-full z-50 transition-all duration-300
        ${scrolled
          ? "bg-white shadow-md border-b"
          : "bg-[#3A9D23]/90 backdrop-blur-md border-b border-white/20"}
      `}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between px-4 md:px-6 py-4">

        {/* LOGO */}
        <Link
          to="/"
          className={`
            font-semibold tracking-tight
            ${scrolled ? "text-gray-900" : "text-white"}
          `}
        >
          Komorotel
        </Link>

        {/* DESKTOP */}
        <div className="hidden md:flex items-center gap-4">

          {user ? (
            <div className="relative">

              {/* USER BUTTON */}
              <button
                onClick={() => setDropdown(!dropdown)}
                className={`
                  flex items-center gap-2 px-3 py-2 rounded-xl
                  ${scrolled ? "hover:bg-gray-100" : "hover:bg-white/10"}
                  transition
                `}
              >
                {/* AVATAR */}
                <div className="w-8 h-8 rounded-full bg-[#3A9D23] text-white flex items-center justify-center text-sm font-medium">
                  {user.name?.[0] || "U"}
                </div>

                <span className={scrolled ? "text-gray-900" : "text-white"}>
                  {user.name}
                </span>

                <ChevronDown size={16} />
              </button>

              {/* DROPDOWN */}
              {dropdown && (
                <div className="
                  absolute right-0 mt-2 w-48
                  bg-white rounded-xl shadow-lg border
                  py-2 z-50
                ">
                  <Link
                    to="/profile"
                    className="block px-4 py-2 text-sm hover:bg-gray-100"
                    onClick={() => setDropdown(false)}
                  >
                    Mon profil
                  </Link>

                  <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                  >
                    Déconnexion
                  </button>
                </div>
              )}

            </div>
          ) : (
            <>
              <Link
                to="/login"
                className={`
                  text-sm
                  ${scrolled ? "text-gray-700" : "text-white/90"}
                `}
              >
                Se connecter
              </Link>

              <Link
                to="/signup"
                className="
                  bg-white text-[#3A9D23]
                  px-4 py-2 rounded-lg text-sm font-medium
                  hover:bg-gray-100 transition
                "
              >
                S'inscrire
              </Link>
            </>
          )}

        </div>

        {/* MOBILE BUTTON */}
        <button
          className={scrolled ? "text-gray-900 md:hidden" : "text-white md:hidden"}
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>

      </div>

      {/* MOBILE MENU */}
      {open && (
        <div className="md:hidden bg-white px-6 py-4 border-t flex flex-col gap-4">

          {user ? (
            <>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-[#3A9D23] text-white flex items-center justify-center">
                  {user.name?.[0]}
                </div>
                {user.name}
              </div>

              <Link to="/profile" onClick={() => setOpen(false)}>
                Mon profil
              </Link>

              <button onClick={handleLogout}>
                Déconnexion
              </button>
            </>
          ) : (
            <>
              <Link to="/login" onClick={() => setOpen(false)}>
                Se connecter
              </Link>

              <Link to="/signup" onClick={() => setOpen(false)}>
                S'inscrire
              </Link>
            </>
          )}

        </div>
      )}
    </header>
  );
}

export default Header;